const ArrowRightSvg = ( { className } ) => {
	return (
		<svg
			width="100%"
			viewBox="0 0 32 32"
			fill="none"
			className={className}
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				// eslint-disable-next-line max-len
				d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM6.73684 17.6498L18.0909 17.6498L13.5641 22.2751L16.6275 25.2632L26.1052 15.5789L16.6275 5.89474L13.5641 8.88277L17.9598 13.3742L6.73684 13.3742L6.73684 17.6498Z"
				fill="currentColor"/>
		</svg>

	);
};
export default ArrowRightSvg;
